export const NAVIGATION = 'cp_navigation'
export const ALERTS = 'cp_alerts'
export const FILES = 'cp_files'
export const IMPORT_ALERT = 'cp_import_alert'
export const EDITABLE_MUI_GRID = 'cp_editable_mui_grid'
export const AXIOS_ERROR_MESSAGE = 'cp_axios_error_message'
export const COPY_TO_CLIPBOARD = 'cp_copy_to_clipboard'